

import { gql } from 'apollo-boost';

export const GET_PAGEVIEWS_BY_DATE = gql`
  query pageViewByRangeDate($dateStart: String!, $dateEnd: String!) {
    pageViewByRangeDate(dateStart: $dateStart, dateEnd: $dateEnd) {
        siteId
        pageViews
    }
  }
`;

export const GET_PAGEVIEWS_INDICATORS = gql`
  query pageViewsIndicators($siteId: String!) {
    pageViewsIndicators(siteId: $siteId) {
      siteId,
      todayPageViews
      yesterdayPageViews
      sevenDaysPageViews
      monthPageViews
      sevenDaysByDaysPageViews { date value }
    }
  }
`;